import { gql } from '../__generated__/gql';

const ACCESS_MEMBERSHIP = gql(`
  mutation AccessMembership($membershipId: String!) {
    accessMembership(membershipId: $membershipId) {
      tenant {
        id
      }
      location {
        id
      }
      lastSeenAt
    }
  }
`);

export default ACCESS_MEMBERSHIP;
